export default __webpack_public_path__ + "static/media/verification_failed.56bc880d.svg";